/*!

=========================================================
* Material Kit PRO React - v1.10.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
// @material-ui icons
// core components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import Info from "components/Typography/Info.js";

import imagesStyles from "assets/jss/material-kit-pro-react/imagesStyles.js";
import cardsStyle from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.js";

import { cardTitle } from "assets/jss/material-kit-pro-react.js";

const style = {
  ...imagesStyles,
  ...cardsStyle,
  cardTitle,
};

const useStyles = makeStyles(style);

export default function CardExampleCardBlog() {
  const classes = useStyles();
  return (
    <Card blog>
      <CardHeader image>
        <a href="#pablo">
          <img
            className={classes.imgCard}
            src="https://images.unsplash.com/photo-1511439817358-bee8e21790b5?auto=format&fit=crop&w=750&q=80&ixid=dW5zcGxhc2guY29tOzs7Ozs%3D"
            alt=""
          />
          <div className={classes.imgCardOverlay}>
            <h4
              className={classes.cardTitle}
              style={{
                color: "white",
                position: "absolute",
                bottom: "10px",
                left: "15px",
              }}
            >
              This Summer Will be Awesome
            </h4>
          </div>
        </a>
      </CardHeader>
      <CardBody>
        <Info>
          <h6 className={classes.cardCategory}>Fashion</h6>
        </Info>
        <p>
          Don't be scared of the truth because we need to restart the human
          foundation in truth And I love you like Kanye loves Kanye I love Rick
          Owens’ bed design but the back is...
        </p>
      </CardBody>
    </Card>
  );
}
